var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/hmrcAPIInfo',["require", "exports", "common/viewmodelbase", "plugins/dialog", 'durandal/app', "areas/informationrequest/models/bindable", "areas/informationrequest/service/sectionapimappings", "areas/informationrequest/service/informationrequest-service", "areas/informationrequest/service/toastDCService"], function (require, exports, common, dialog, app, VM, sectionapimappings, service, toastService) {
    "use strict";
    var hmrcAPIInfoViewModel = (function (_super) {
        __extends(hmrcAPIInfoViewModel, _super);
        function hmrcAPIInfoViewModel() {
            _super.call(this);
            this.sections = new Array();
            this.spouseInfo = new VM.SpouseInfo();
            this.showMaImages = ko.observable(false);
            this.showNicImages = ko.observable(false);
            this.hasHmrcAuthorisation = ko.observable(false);
            ko.track(this, ["sections", "informationText", "infoStep", "newSpouseInfo"]);
            this.toastDCService = new toastService.ToastDCService();
            // this.index = 0;
            this.yesTag = 'Yes';
            this.noTag = 'No';
            this.informationrequestService = new service.InformationRequestService();
        }
        hmrcAPIInfoViewModel.prototype.onActivated = function (context) {
        };
        hmrcAPIInfoViewModel.prototype.Load = function (hmrcInfo, spouseInfoFromPT, spouseInfo, yearToDisplay) {
            this.hmrcInformation = hmrcInfo;
            this.sections = new Array();
            this.currentYearHeader = yearToDisplay;
            var section = new VM.HmrcSectionVM();
            section.extraFieldsType = "MarriageAllowance";
            section.name = sectionapimappings.SectionAPIMapping.MASectionName;
            section.nameId = section.name.replace(/ /g, '');
            if (this.hmrcInformation.apiErrors != null &&
                this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.MASectionName)]) {
                var error = this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.MASectionName)][0];
                if (error.statusCode == 404) {
                    section.hasHMRCAPI404Error(true);
                    section.showChevron(true);
                }
                else {
                    section.hasHMRCAPIError(true);
                }
            }
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.maStatusDesc;
            if (hmrcInfo.marriageAllowanceStatus != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.marriageAllowanceStatus.status);
                childSection.hasHmrcIcon = true;
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.maDeceasedDesc;
            if (hmrcInfo.marriageAllowanceStatus != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.marriageAllowanceStatus.deceased);
                childSection.hasHmrcIcon = true;
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            childSection = new VM.HmrcSectionVM();
            childSection.name = hmrcAPIInfoViewModel.maEligible;
            if (hmrcInfo.marriageAllowanceEligibility != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.marriageAllowanceEligibility.eligible);
                childSection.hasHmrcIcon = true;
                childSection.isVisible(false);
            }
            else {
                this.errorMesage = "Details missing";
                childSection.hasHmrcIcon = false;
                childSection.thisyear = this.errorMesage;
                childSection.isVisible(false);
            }
            childSection.spouseInfo = VM.SpouseInfo.loadFromInfoRequest(spouseInfoFromPT);
            childSection.newSpouseInfo = VM.SpouseInfo.loadFromInfoRequest(spouseInfo);
            //childSection.hasSpouse = true;
            this.setSpouseWarnings(childSection);
            this.hasInvalidForenameWarning(childSection, true);
            this.hasInvalidSurnameWarning(childSection, true);
            this.hasInvalidNINoWarning(childSection, true);
            this.hasInvalidDobWarning(childSection, true);
            this.hasInvalidDomWarning(childSection, true);
            section.children.push(childSection);
            this.LoadPensions(hmrcInfo);
            this.sections.push(section);
            this.LoadNic(hmrcInfo);
        };
        hmrcAPIInfoViewModel.prototype.setSpouseWarnings = function (childSection) {
            if (childSection.newSpouseInfo == null)
                return;
            if (childSection.newSpouseInfo.spouseFName != "-")
                childSection.hasWarningMissingFName(false);
            else
                childSection.newSpouseInfo.spouseFName = "";
            if (childSection.newSpouseInfo.spouseSurname != "-")
                childSection.hasWarningMissingSurName(false);
            else
                childSection.newSpouseInfo.spouseSurname = "";
            if (childSection.newSpouseInfo.spouseNINO != "-")
                childSection.hasWarningMissingNINO(false);
            else
                childSection.newSpouseInfo.spouseNINO = "";
            if (childSection.newSpouseInfo.spouseDOB != "-")
                childSection.hasWarningMissingdob(false);
            else
                childSection.newSpouseInfo.spouseDOB = "";
            // we don't have missing DOM date warning
            childSection.hasWarningMissingdom(false);
            if (childSection.newSpouseInfo.dom == "-")
                childSection.newSpouseInfo.dom = "";
        };
        hmrcAPIInfoViewModel.prototype.LoadHmrcValues = function (hmrcInfo) {
            this.latestHmrcInformation = hmrcInfo;
            if (this.sections != null) {
                for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
                    var section = _a[_i];
                    switch (section.name) {
                        case sectionapimappings.SectionAPIMapping.MASectionName:
                            this.LoadMAHmrcValues(hmrcInfo, section);
                            this.setErrorFlags(hmrcInfo, section);
                            section.showChevron(true);
                            break;
                        case sectionapimappings.SectionAPIMapping.NICSectionName:
                            this.LoadNICHmrcValues(hmrcInfo, section);
                            var hasError = this.setErrorFlags(hmrcInfo, section);
                            section.showChevron(!hasError);
                            break;
                        case sectionapimappings.SectionAPIMapping.PensionsAnnuities:
                            this.LoadPensionsHmrcValues(hmrcInfo, section);
                            var hasError = this.setErrorFlags(hmrcInfo, section);
                            section.showChevron(!hasError);
                            break;
                    }
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.showDetails = function (section, event) {
            app.showDialog("areas/informationrequest/viewmodels/spousePartnerInfo", section.spousePartnerInfo);
        };
        hmrcAPIInfoViewModel.prototype.LoadMAHmrcValues = function (hmrcInfo, section) {
            for (var _i = 0, _a = section.children; _i < _a.length; _i++) {
                var childSectionVM = _a[_i];
                if (childSectionVM instanceof VM.HmrcSectionVM) {
                    var childSection = childSectionVM;
                    switch (childSection.name) {
                        case hmrcAPIInfoViewModel.maStatusDesc:
                            if (hmrcInfo.marriageAllowanceStatus != null) {
                                childSection.lasthmrcvalue(this.getReadableValue(hmrcInfo.marriageAllowanceStatus.status));
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            else {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            break;
                        case hmrcAPIInfoViewModel.maDeceasedDesc:
                            if (hmrcInfo.marriageAllowanceStatus != null) {
                                childSection.lasthmrcvalue(this.getReadableValue(hmrcInfo.marriageAllowanceStatus.deceased));
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            else {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            break;
                        case hmrcAPIInfoViewModel.maEligible:
                            childSection.isVisible(false);
                            break;
                    }
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.LoadNICHmrcValues = function (hmrcInfo, section) {
            for (var _i = 0, _a = section.children; _i < _a.length; _i++) {
                var childSectionVM = _a[_i];
                if (childSectionVM instanceof VM.HmrcSectionVM) {
                    var childSection = childSectionVM;
                    switch (childSection.name) {
                        case hmrcAPIInfoViewModel.nicTotalNiCableEarnings:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.isAmountNic = false;
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                childSection.lasthmrcvalue("£ " + this.getReadableValue(hmrcInfo.nationalInsurance.class1.totalNiCableEarnings).toFixed(2));
                                childSection.isAmountNic = true;
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.nicTotalDue:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.isAmountNic = false;
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                childSection.lasthmrcvalue("£ " + this.getReadableValue(hmrcInfo.nationalInsurance.class2.totalDue).toFixed(2));
                                childSection.isAmountNic = true;
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.nicMaxNiCsReached:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                childSection.lasthmrcvalue(this.getReadableValue(hmrcInfo.nationalInsurance.maxNiCsReached));
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                    }
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.LoadPensionsHmrcValues = function (hmrcInfo, section) {
            for (var _i = 0, _a = section.children; _i < _a.length; _i++) {
                var childSectionVM = _a[_i];
                if (childSectionVM instanceof VM.HmrcSectionVM) {
                    var childSection = childSectionVM;
                    switch (childSection.name) {
                        case hmrcAPIInfoViewModel.pensionsIncomeOtherPensions:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                var lastHmrcValue = "";
                                if (hmrcInfo.individualIncome && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities)
                                    lastHmrcValue = "£ " + hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities.toFixed(2);
                                childSection.lasthmrcvalue(lastHmrcValue);
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.pensionsIncomeJobseekersAllowance:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                var lastHmrcValue = "";
                                if (hmrcInfo.individualIncome && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.jobseekersAllowance)
                                    lastHmrcValue = "£ " + hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.jobseekersAllowance.toFixed(2);
                                childSection.lasthmrcvalue(lastHmrcValue);
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.pensionsIncomeIncapacityBenefit:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                var lastHmrcValue = "";
                                if (hmrcInfo.individualIncome && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit)
                                    lastHmrcValue = "£ " + hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit.toFixed(2);
                                childSection.lasthmrcvalue(lastHmrcValue);
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.pensionsTaxOtherPensions:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                var lastHmrcValue = "";
                                if (hmrcInfo.individualTax && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities)
                                    lastHmrcValue = "£ " + hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities.toFixed(2);
                                childSection.lasthmrcvalue(lastHmrcValue);
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                        case hmrcAPIInfoViewModel.pensionsTaxIncapacityBenefit:
                            if (hmrcInfo.nationalInsurance == null) {
                                childSection.lasthmrcvalue("");
                                childSection.hasHmrcIcon = false;
                            }
                            else {
                                var lastHmrcValue = "";
                                if (hmrcInfo.individualTax && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit)
                                    lastHmrcValue = "£ " + hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit.toFixed(2);
                                childSection.lasthmrcvalue(lastHmrcValue);
                                childSection.hasHmrcIcon = true;
                                childSection.isVisible(true);
                                section.isFromHmrc(true);
                            }
                            break;
                    }
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.LoadPensions = function (hmrcInfo) {
            var section = new VM.HmrcSectionVM();
            section.name = sectionapimappings.SectionAPIMapping.PensionsAnnuities;
            section.nameId = section.name.replace(/ /g, '');
            section.extraFieldsType = "NationalInsuranceContributions";
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.pensionsIncomeOtherPensions;
            if (hmrcInfo.individualIncome != null && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits != null
                && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
                section.isFromHmrc(true);
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.pensionsTaxOtherPensions;
            if (hmrcInfo.individualTax != null && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits != null
                && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.otherPensionsAndRetirementAnnuities).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
                section.isFromHmrc(true);
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.pensionsIncomeIncapacityBenefit;
            if (hmrcInfo.individualIncome != null && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits != null
                && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
                section.isFromHmrc(true);
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.pensionsTaxIncapacityBenefit;
            if (hmrcInfo.individualTax != null && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits != null
                && hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.individualTax.pensionsAnnuitiesAndOtherStateBenefits.incapacityBenefit).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
                section.isFromHmrc(true);
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.pensionsIncomeJobseekersAllowance;
            if (hmrcInfo.individualIncome != null && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits != null
                && hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.jobseekersAllowance != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.individualIncome.pensionsAnnuitiesAndOtherStateBenefits.jobseekersAllowance).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
                section.isFromHmrc(true);
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            section.showChevron(true);
            if (this.hmrcInformation.apiErrors != null &&
                this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.PensionsAnnuities)]) {
                var error = this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.PensionsAnnuities)][0];
                if (error.statusCode == 404) {
                    section.hasHMRCAPI404Error(true);
                }
                else {
                    section.hasHMRCAPIError(false);
                }
            }
            this.sections.push(section);
        };
        hmrcAPIInfoViewModel.prototype.LoadNic = function (hmrcInfo) {
            var section = new VM.HmrcSectionVM();
            section.name = sectionapimappings.SectionAPIMapping.NICSectionName;
            section.nameId = section.name.replace(/ /g, '');
            section.extraFieldsType = "NationalInsuranceContributions";
            var childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.nicTotalNiCableEarnings;
            if (hmrcInfo.nationalInsurance != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.nationalInsurance.class1.totalNiCableEarnings).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.nicTotalDue;
            if (hmrcInfo.nationalInsurance != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.nationalInsurance.class2.totalDue).toFixed(2);
                childSection.isAmountNic = true;
                childSection.hasHmrcIcon = true;
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            childSection = new VM.HmrcSectionVM;
            childSection.name = hmrcAPIInfoViewModel.nicMaxNiCsReached;
            if (hmrcInfo.nationalInsurance != null) {
                childSection.thisyear = this.getReadableValue(hmrcInfo.nationalInsurance.maxNiCsReached);
                childSection.hasHmrcIcon = true;
            }
            else {
                childSection.thisyear = '';
                childSection.isVisible(false);
            }
            section.children.push(childSection);
            if (this.hmrcInformation.apiErrors != null &&
                this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.NICSectionName)]) {
                var error = this.hmrcInformation.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(sectionapimappings.SectionAPIMapping.NICSectionName)][0];
                if (error.statusCode == 404) {
                    section.hasHMRCAPI404Error(true);
                    section.showChevron(false);
                }
                else {
                    section.hasHMRCAPIError(true);
                }
            }
            this.sections.push(section);
        };
        hmrcAPIInfoViewModel.prototype.setErrorFlags = function (hmrcInfo, section) {
            section.hasHMRCAPI404Error(false);
            section.hasHMRCAPIError(false);
            if (hmrcInfo.apiErrors == null) {
                return false;
            }
            if (hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(section.name)]) {
                for (var _i = 0, _a = hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(section.name)]; _i < _a.length; _i++) {
                    var error = _a[_i];
                    if (error.statusCode == 404) {
                        section.hasHMRCAPI404Error(true);
                    }
                    else {
                        section.hasHMRCAPIError(true);
                    }
                }
                return true;
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.closeDialog = function (section, event) {
            dialog.close(this);
        };
        hmrcAPIInfoViewModel.prototype.rootClicked = function (section) {
            if (section.children.length > 0 && section.showChevron())
                section.expanded(!section.expanded());
        };
        hmrcAPIInfoViewModel.prototype.errorClicked = function (section) {
            var self = this;
            self.selectedSectionName = section.name;
            self.showErrors();
        };
        hmrcAPIInfoViewModel.prototype.showErrors = function () {
            var hmrcInfo = this.latestHmrcInformation;
            if (this.latestHmrcInformation == null)
                hmrcInfo = this.hmrcInformation;
            if (hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(this.selectedSectionName)]) {
                var error404Description = this.selectedSectionName;
                var has500Error = false;
                var has404Error = false;
                for (var i = 0; i < hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(this.selectedSectionName)].length; i++) {
                    var error = hmrcInfo.apiErrors[sectionapimappings.SectionAPIMapping.GetHMRCAPIType(this.selectedSectionName)][i];
                    var toastMessage = this.ConstructToastMessage(error);
                    if (error.statusCode == 400 || error.statusCode == 401)
                        this.toastDCService.constructDCToast('fail', toastMessage);
                    if (error.statusCode == 404) {
                        if (error.aPIName != null)
                            error404Description = error404Description + " <br> - " + error.aPIName;
                        else
                            error404Description = error404Description;
                        has404Error = true;
                    }
                    if (error.statusCode == 500) {
                        has500Error = true;
                    }
                }
                if (has404Error)
                    this.toastDCService.constructDCToast('success', "Sorry! No data currently held by HMRC : <br>" + error404Description);
                if (has500Error)
                    this.toastDCService.constructDCToast('fail', "Server Error : Internal server error");
            }
        };
        hmrcAPIInfoViewModel.prototype.ConstructToastMessage = function (error) {
            var errorMessage = "";
            if (error.aPIName != null && error.aPIName.length > 0) {
                this.errorMesage = this.selectedSectionName + " : " + error.aPIName + " - " + error.reasonPhrase + " : " + error.errorDescription;
            }
            else {
                this.errorMesage = this.selectedSectionName + " : " + error.reasonPhrase + " - " + error.errorDescription;
            }
            return this.errorMesage;
        };
        hmrcAPIInfoViewModel.prototype.getReadableValue = function (anyValue) {
            if (anyValue === true)
                return this.yesTag;
            else if (anyValue === false)
                return this.noTag;
            else
                return anyValue;
        };
        hmrcAPIInfoViewModel.prototype.showInformation = function (section, event) {
            var self = this;
            if (section.extraFieldsType == "MarriageAllowance") {
                self.showMaImages(true);
                self.showNicImages(false);
            }
            else if (section.extraFieldsType == "NationalInsuranceContributions") {
                self.showNicImages(true);
                self.showMaImages(false);
            }
            self.informationText = "  This column is a snapshot of the data held by HMRC when the Digital Tax request was created for your client. " +
                "It is what your client sees where the information is relevant to the collection of their data.";
            self.infoStep = "1";
            $("#dialogInfoId").modal("show");
        };
        hmrcAPIInfoViewModel.prototype.doNext = function () {
            var self = this;
            self.infoStep = "2";
            self.informationText = "  This column provides an up-to-date view of the information HMRC currently holds for your client.";
        };
        hmrcAPIInfoViewModel.prototype.doPrevious = function () {
            var self = this;
            self.informationText = "  This column is a snapshot of the data held by HMRC when the Digital Tax request was created for your client. " +
                "It is what your client sees where the information is relevant to the collection of their data.";
            self.infoStep = "1";
        };
        hmrcAPIInfoViewModel.prototype.closeInfoDialog = function () {
            var self = this;
            self.showMaImages(false);
            self.showNicImages(false);
            $("#dialogInfoId").modal("hide");
        };
        hmrcAPIInfoViewModel.prototype.togleWarningFname = function (section, event) {
            section.hasWarningMissingFName(false);
            section.hasWarningInvalidFname(false);
        };
        hmrcAPIInfoViewModel.prototype.togleWarningSurNme = function (section, event) {
            section.hasWarningMissingSurName(false);
            section.hasWarningInvalidSurname(false);
        };
        hmrcAPIInfoViewModel.prototype.togleWarningNINO = function (section, event) {
            section.hasWarningMissingNINO(false);
            section.hasWarningInvalidNINO(false);
        };
        hmrcAPIInfoViewModel.prototype.togleWarningdob = function (section, event) {
            section.hasWarningMissingdob(false);
            section.hasWarningInvalidDob(false);
            $("#spouseDob").datepicker({ format: "DD/MM/YYYY" });
        };
        hmrcAPIInfoViewModel.prototype.togleWarningdom = function (section, event) {
            section.hasWarningMissingdom(false);
            section.hasWarningInvalidDom(false);
            $("#spouseDom").datepicker({ format: "DD/MM/YYYY" });
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidSpouseFields = function () {
            var section = this.findMAEligibilitySection();
            if (section != null && !VM.SpouseInfo.isEmpty(section.newSpouseInfo))
                return this.hasInvalidFields(section);
            return false;
        };
        hmrcAPIInfoViewModel.prototype.hasChangedSpouseInfo = function (spInfo) {
            var section = this.findMAEligibilitySection();
            if (section != null) {
                var newValue = section.newSpouseInfo == null ? null : section.newSpouseInfo.getModelForExport();
                var originalValue = VM.SpouseInfo.loadFromInfoRequest(spInfo);
                if (originalValue != null)
                    originalValue = originalValue.getModelForExport();
                if (newValue == null && originalValue != null ||
                    newValue != null && !newValue.IsEqual(originalValue))
                    return true;
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.getHmrcSpouseInfo = function () {
            var section = this.findMAEligibilitySection();
            if (section != null) {
                return section.newSpouseInfo.getModelForExport();
            }
            return null;
        };
        hmrcAPIInfoViewModel.prototype.getParrentSection = function (childParrentGuid) {
            for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
                var section = _a[_i];
                switch (section.parentGuid) {
                    case childParrentGuid:
                        return section;
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.findMAEligibilitySection = function () {
            if (this.sections != null) {
                for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
                    var section = _a[_i];
                    switch (section.name) {
                        case sectionapimappings.SectionAPIMapping.MASectionName:
                            return this.findMAEligibilityChildSection(section);
                    }
                }
            }
            return null;
        };
        hmrcAPIInfoViewModel.prototype.findMAEligibilityChildSection = function (maSection) {
            if (maSection == null)
                return null;
            for (var _i = 0, _a = maSection.children; _i < _a.length; _i++) {
                var section = _a[_i];
                switch (section.name) {
                    case hmrcAPIInfoViewModel.maEligible:
                        return section;
                }
            }
        };
        hmrcAPIInfoViewModel.prototype.getSpouseInfoFromEncodedString = function (spouseInformationString) {
            var spInfo = null;
            if (spouseInformationString != null) {
                var tempSpouse = atob(spouseInformationString);
                tempSpouse = tempSpouse.replace(/"([^"]+)":/g, function ($0, $1) { return ('"' + $1[0].toLowerCase() + $1.slice(1) + '":'); });
                spInfo = JSON.parse(tempSpouse);
            }
            return spInfo;
        };
        hmrcAPIInfoViewModel.prototype.getEncodedSpouseInfo = function (spInfo) {
            if (spInfo == null || VM.SpouseInfo.isEmpty(spInfo)) {
                return null;
            }
            return btoa(JSON.stringify(spInfo));
        };
        hmrcAPIInfoViewModel.prototype.validateSpouseForname = function (section, event) {
            section.hasWarningMissingFName(false);
            section.hasWarningInvalidFname(false);
            this.hasInvalidForenameWarning(section, false);
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidForenameWarning = function (childSection, firstEntry) {
            if (childSection.newSpouseInfo.spouseFName == null || childSection.newSpouseInfo.spouseFName == "") {
                childSection.hasWarningMissingFName(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "Forename is missing");
                return true;
            }
            else if (this.containsNumber(childSection.newSpouseInfo.spouseFName)) {
                childSection.hasWarningInvalidFname(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "Forename entered is invalid");
                return true;
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.validateSpouseSurname = function (section, event) {
            section.hasWarningMissingSurName(false);
            section.hasWarningInvalidSurname(false);
            this.hasInvalidSurnameWarning(section, false);
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidSurnameWarning = function (childSection, firstEntry) {
            if (childSection.newSpouseInfo.spouseSurname == null || childSection.newSpouseInfo.spouseSurname == "") {
                childSection.hasWarningMissingSurName(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "Surname is missing");
                return true;
            }
            else if (this.containsNumber(childSection.newSpouseInfo.spouseSurname)) {
                childSection.hasWarningInvalidSurname(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "Surname entered is invalid");
                return true;
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.validateSpouseNINO = function (section, event) {
            this.hasInvalidNINoWarning(section, false);
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidNINoWarning = function (childSection, firstEntry) {
            if (childSection.newSpouseInfo.spouseNINO == null || childSection.newSpouseInfo.spouseNINO == "") {
                childSection.hasWarningMissingNINO(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "NI No. is missing");
                return true;
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.validateSpouseDob = function (section, event) {
            section.hasWarningMissingdob(false);
            section.hasWarningInvalidDob(false);
            this.hasInvalidDobWarning(section, false);
        };
        hmrcAPIInfoViewModel.prototype.validateSpouseDom = function (section, event) {
            this.hasInvalidDomWarning(section, false);
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidDobWarning = function (childSection, firstEntry) {
            if (childSection.newSpouseInfo.spouseDOB == null || childSection.newSpouseInfo.spouseDOB == "") {
                childSection.hasWarningMissingdob(true);
                if (!firstEntry)
                    this.toastDCService.constructDCToast('fail', "Date of birth is missing");
                return true;
            }
            else {
                var tempDate = childSection.newSpouseInfo.spouseDOB.split('/');
                var dobDate = new Date(tempDate[2], tempDate[1] - 1, tempDate[0]);
                var dateNow = new Date();
                if (dobDate > dateNow) {
                    childSection.hasWarningInvalidDob(true);
                    childSection.hasWarningMissingdob(false);
                    if (!firstEntry)
                        this.toastDCService.constructDCToast('fail', "Date of birth entered is invalid");
                    return true;
                }
            }
            this.hasInvalidDomWarning(childSection, firstEntry);
            return false;
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidDomWarning = function (childSection, firstEntry) {
            if (childSection.newSpouseInfo.spouseDOB != null && childSection.newSpouseInfo.spouseDOB != "" &&
                childSection.newSpouseInfo.dom != null && childSection.newSpouseInfo.dom != "") {
                var tempDomDate = childSection.newSpouseInfo.dom.split('/');
                var tempDobDate = childSection.newSpouseInfo.spouseDOB.split('/');
                var domDate = new Date(tempDomDate[2], tempDomDate[1] - 1, tempDomDate[0]);
                var dobDate = new Date(tempDobDate[2], tempDobDate[1] - 1, tempDobDate[0]);
                if (dobDate > domDate) {
                    childSection.hasWarningInvalidDom(true);
                    childSection.hasWarningMissingdom(false);
                    if (!firstEntry)
                        this.toastDCService.constructDCToast('fail', "Date of marriage entered is invalid");
                    return true;
                }
                else
                    childSection.hasWarningMissingdom(false);
            }
            return false;
        };
        hmrcAPIInfoViewModel.prototype.hasInvalidFields = function (section) {
            if (!this.hasInvalidForenameWarning(section, true) && !this.hasInvalidSurnameWarning(section, true) && !this.hasInvalidNINoWarning(section, true) && !this.hasInvalidDobWarning(section, true) && !this.hasInvalidDomWarning(section, true)) {
                return false;
            }
            return true;
        };
        hmrcAPIInfoViewModel.prototype.containsNumber = function (dateString) {
            return /\d/.test(dateString);
        };
        hmrcAPIInfoViewModel.maStatusDesc = "Taxpayer's existing status";
        hmrcAPIInfoViewModel.maDeceasedDesc = "Is taxpayer deceased?";
        hmrcAPIInfoViewModel.maEligible = "Is taxpayer's spouse/civil partner eligible?";
        hmrcAPIInfoViewModel.nicTotalNiCableEarnings = "Total earnings liable to Class 1 NIC above PT and up to UEL";
        hmrcAPIInfoViewModel.nicTotalDue = "Class 2 NIC total due";
        hmrcAPIInfoViewModel.nicMaxNiCsReached = "Have maximum NI contributions been reached?";
        hmrcAPIInfoViewModel.pensionsIncomeOtherPensions = "Total pay from all pensions & retirement annuities (excluding State Pension)";
        hmrcAPIInfoViewModel.pensionsIncomeIncapacityBenefit = "Incapacity Benefits payments received";
        hmrcAPIInfoViewModel.pensionsIncomeJobseekersAllowance = "Jobseeker's Allowance payments received";
        hmrcAPIInfoViewModel.pensionsTaxOtherPensions = "Total tax deducted from all pensions & retirement annuities";
        hmrcAPIInfoViewModel.pensionsTaxIncapacityBenefit = "Total tax deducted from Incapacity Benefits";
        return hmrcAPIInfoViewModel;
    }(common.ListViewModelBase));
    exports.hmrcAPIInfoViewModel = hmrcAPIInfoViewModel;
});

